import { STATICIMAGESBASEPATH } from "../constants/Constants";
import { StaticImages } from "../constants/StaticImages";
import { STATICIMAGEEXTENSIONS } from "../constants/StaticImageExtensions";



function canUseWebP(): boolean {
    const elem = document.createElement('canvas');
    if (elem.getContext && elem.getContext('2d')) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } else {
        return false;
    }
}

// determine if the browser support webp images
const webpSupported = canUseWebP();
// based on that we select the extension to use for the static img
export const imageExtension = webpSupported ? STATICIMAGEEXTENSIONS.WEBP : STATICIMAGEEXTENSIONS.PNG;





export function getStaticImagePaths(): Iterable<readonly [PropertyKey, string]> {
    return Object.entries(StaticImages).map(([key, value]) => [key, `${STATICIMAGESBASEPATH}${value}.${imageExtension}`]);
}
